import React from 'react'
import styled from 'styled-components'
import Contact from './Contact'

const About = ({Text}) => {
  return (
    <AboutContainer>
      <Text/>
      <Contact/>
    </AboutContainer>
  )
}

const AboutContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.5rem;
  padding-top: 5rem;
  font-size: 16px;
  gap: 1rem;
`


export default About